import BaseSvg, { Props } from '../BaseSvg'

const HouseSmall: React.FC<Props> = (props) => (
  <BaseSvg {...props}>
    <path d="M8 0L16 4.44444V16H0V4.44444L8 0ZM8 2.288L2 5.62V14H8.53L7.753 11.101L5.36104 11.7424L4.58458 8.84461L11.3461 7.03287L12.1225 9.93065L9.685 10.583L10.6 14H14V5.621L8 2.288Z" />
  </BaseSvg>
)

export default HouseSmall
